import React from "react";
import WlfAttempt from 'components/sports/wlf/views/WlfAttempt';
import Label from "components/general/Label";

const WlfExtendedResul = (props) => {

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <td></td>
            <th scope="col" className="text-end w-20">1</th>
            <th scope="col" className="text-end w-20">2</th>
            <th scope="col" className="text-end w-20">3</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" className="fw-bold text-end"><Label data="HeaderSnatch" sport='WLF' /></th>
            <td className='text-end'>
              <WlfAttempt data={props?.data} code='SNATCH' pos='1' />
            </td>
            <td className='text-end'>
              <WlfAttempt data={props?.data} code='SNATCH' pos='2' />
            </td>
            <td className='text-end'>
              <WlfAttempt data={props?.data} code='SNATCH' pos='3' />
            </td>
          </tr>
          <tr>
            <th scope="row" className="fw-bold text-end"><Label data="HeaderCleanLong" sport='WLF' /></th>
            <td className='text-end'>
              <WlfAttempt data={props?.data} code='CLEAN' pos='1' />
            </td>
            <td className='text-end'>
              <WlfAttempt data={props?.data} code='CLEAN' pos='2' />
            </td>
            <td className='text-end'>
              <WlfAttempt data={props?.data} code='CLEAN' pos='3' />
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
};

export default WlfExtendedResul;